/*
 * @Descripttion:
 * @version:
 * @Author: 孙鑫鑫
 * @Date: 2022-03-10 15:44:02
 * @LastEditors: 孙鑫鑫
 * @LastEditTime: 2022-04-28 09:25:38
 */
import Vue from "vue";
import Router from "vue-router";
import routerConfig from "@/router/routes";
import store from "@/store";
import { dispatch } from "frer";

Vue.use(Router);

const router = new Router({
  routes: routerConfig,
});

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  if (to.path == "/login" && token && !localStorage.getItem("tokenExpire")) {
    next("/index");
  } else if (localStorage.getItem("tokenExpire")) {
    localStorage.removeItem("tokenExpire");
  }
  if (to.path == "/audit/mine") {
    store.state.common.activeIndex = "/audit";
  } else if (
    to.path == "/notice" ||
    to.path == "/password"
  ) {
    store.state.common.activeIndex = "/index";
  } else if (to.path == "/tools/job/add") {
    store.state.common.activeIndex = "/tools/job/index";
  } else if (to.path == "/shortPlay/detail") {
    store.state.common.activeIndex = "/shortPlay";
  } else {
    store.state.common.activeIndex = to.path;
  }
  next();
});
export default router;
